<template>
  <div class="promotion">
    <div class="header">
      <div class="container">
        <div class="header-main">
          <div class="logo" style="width: 200px">
            <!--            <img src="./img/promotion/logo.png">-->
            <img src="./img/promotion/256.webp">
          </div>
          <div class="top">
            <ul>
              <li><span class="one"> </span>
                <p><a href="mailto:example@gmail.com">2822863301@qq.com</a></p></li>
              <li><span class="two"> </span>
                <p>15225826875</p></li>
            </ul>
          </div>
          <!--  bottom   -->
          <div class="bottom">
            <div class="col-md-4 bottom-left">
              <h1>什么是Ai绘画</h1>
              <p class="para">
                AI绘画是一款应用程序，通常在手机上使用。如果您想在电脑上使用AI绘画，可以尝试使用应用宝电脑版，并允许您下载和使用AI绘画应用程序。</p>
              <h3>——功能介绍——</h3>
              <ul>
                <li><p>多种分类，壁纸、头像、DIY物品自由创作</p></li>
                <li><p>古风、写实、二次元、机械感等超多艺术风格</p></li>
                <li><p>作品分类，帮你保存灵感，记录属于自己的创作</p></li>
              </ul>
              <div class="bttn">
                <a href="https://27809b66b8038499a45e2db9ef5a47763b770b7c2d1c40cb.dlied1.cdntips.net/imtt2.dd.qq.com/sjy.00009/sjy.00004/16891/apk/07993C811149D66BD46F62F97125888E.apk?mkey=lego_ztc&f=00&sche_type=7&fsname=com.wm.aidraw_1.1.16.apk&cip=240e:33e:3d1f:4300:e40b:25b8:544d:1297&proto=https">
                  <span class="ph"> </span>
                  <div class="d-1">
                    <p class="a">可以在以下网站获取</p>
                    <h6>应用宝</h6>
                  </div>
                </a>
              </div>
              <p class="para1">* 先阅读条款和条件</p>
            </div>

            <div class="col-md-4 bottom-middle">
              <img src="./img/promotion/iph.png" alt="">
<!--              <img src="https://pp.myapp.com/ma_pic2/0/shot_54298855_2_1727315292/0" alt="">-->
            </div>

            <div class="col-md-4 bottom-right">
              <div class="bottom-right-top">
                <div class="callbacks_container">
                  <ul class="rslides callbacks callbacks1" id="slider">
                    <li id="callbacks1_s0" class=""
                        style="display: block; transition: opacity 500ms ease-in-out 0s; float: none; position: absolute; opacity: 0; z-index: 0;">
                      <div class="col-md-4 bottom-right-top-left">
                        <img src="./img/promotion/drop.png" alt="">
                      </div>
                      <div class="col-md-8 bottom-right-top-right">
                        <h3>各种风格</h3>
                        <p>无论是文生图还是图生图，都有各种风格可以选择，总有一款适合你</p>
                      </div>
                      <div class="clearfix"></div>
                    </li>
                    <li id="callbacks1_s1" class=""
                        style="display: list-item; transition: opacity 500ms ease-in-out 0s; float: none; position: absolute; opacity: 1; z-index: 1;">
                      <div class="col-md-4 bottom-right-top-left">
                        <img src="./img/promotion/drop.png" alt="">
                      </div>
                      <div class="col-md-8 bottom-right-top-right">
                        <h3>图片保存</h3>
                        <p>电子绘画作品，生成的图片您可以保存珍藏，也可以分享给朋友。</p>
                      </div>
                      <div class="clearfix"></div>
                    </li>
                    <li id="callbacks1_s2" class=""
                        style="display: list-item; transition: opacity 500ms ease-in-out 0s; float: left; position: relative; opacity: 0; z-index: 2;">
                      <div class="col-md-4 bottom-right-top-left">
                        <img src="./img/promotion/drop.png" alt="">
                      </div>
                      <div class="col-md-8 bottom-right-top-right">
                        <h3>优秀作品</h3>
                        <p>应用内展示了很多精美的实例图片，或许可以激发您的创作灵感。</p>
                      </div>
                      <div class="clearfix"></div>
                    </li>
                  </ul>
                  <a href="#" class="callbacks_nav callbacks1_nav prev">Previous</a>
                  <a href="#" class="callbacks_nav callbacks1_nav next">Next</a>
                  <ul class="callbacks_tabs callbacks1_tabs">
                    <li class="callbacks1_s1 callbacks_here"><a href="#" class="callbacks1_s1">1</a></li>
                    <li class="callbacks1_s2 "><a href="#" class="callbacks1_s2">2</a></li>
                    <li class="callbacks1_s3 "><a href="#" class="callbacks1_s3">3</a></li>
                  </ul>
                </div>
              </div>

              <div class="slide">
                <div class="nbs-flexisel-container">
                  <div class="nbs-flexisel-inner">
                    <ul id="flexiselDemo3" class="nbs-flexisel-ul" style="display: block; left: -113.333px;">

                      <li class="nbs-flexisel-item" style="width: 113.333px;">
                        <img src="./img/promotion/shili2.png" alt="">
                      </li>
                      <li class="nbs-flexisel-item" style="width: 113.333px;">
                        <img src="./img/promotion/shili3.png" alt="">
                      </li>
                      <li class="nbs-flexisel-item" style="width: 113.333px;">
                        <img src="./img/promotion/shili1.png" alt="">
                      </li>
                      <li class="nbs-flexisel-item" style="width: 113.333px;">
                        <img src="./img/promotion/shili2.png" alt="">
                      </li>
                      <li class="nbs-flexisel-item" style="width: 113.333px;">
                        <img src="./img/promotion/shili3.png" alt="">
                      </li>
                      <li class="nbs-flexisel-item" style="width: 113.333px;">
                        <img src="./img/promotion/shili1.png" alt="">
                      </li>
                    </ul>
                    <div class="nbs-flexisel-nav-left" style="top: 47.5px;"></div>
                    <div class="nbs-flexisel-nav-right" style="top: 47.5px;"></div>
                  </div>
                </div>
              </div>
              <div class="bottom-bottom">
                <div class="callbacks_container">
                  <ul class="rslides callbacks callbacks2" id="slider1">
                    <li id="callbacks2_s0" class=""
                        style="display: block; transition: opacity 500ms ease-in-out 0s; float: none; position: absolute; opacity: 0; z-index: 1;">
                      <div class="btm-btm">
                        <p>"该应用提供了丰富多样的功能，能够满足用户的各种需求，操作简单易上手！"</p>
                        <div class="bottom-bottom-one">
                          <i><img src="./img/promotion/touxiang1.png" alt=""></i>
                          <div class="btm">
                            <h4>John Doe</h4>
                            <a href="mailto:example@gmail.com">www.Fikristudio.com</a>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li id="callbacks2_s1" class=""
                        style="display: list-item; transition: opacity 500ms ease-in-out 0s; float: none; position: absolute; opacity: 0; z-index: 1;">
                      <div class="btm-btm">
                        <p>"应用提供了丰富的个性化设置选项，用户可以根据自己的喜好进行创作！"</p>
                        <div class="bottom-bottom-one">
                          <i><img src="./img/promotion/touxiang2.png" alt=""></i>
                          <div class="btm">
                            <h4>John Doe</h4>
                            <a href="mailto:example@gmail.com">www.Fikristudio.com</a>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li id="callbacks2_s2" class="callbacks2_on"
                        style="display: list-item; transition: opacity 500ms ease-in-out 0s; float: left; position: relative; opacity: 1; z-index: 2;">
                      <div class="btm-btm">
                        <p>"应用交互设计人性化，操作逻辑清晰，可以轻松上手，无需复杂的学习过程！"</p>
                        <div class="bottom-bottom-one">
                          <i><img src="./img/promotion/touxiang3.png" alt=""></i>
                          <div class="btm">
                            <h4>John Doe</h4>
                            <a href="mailto:example@gmail.com">www.Fikristudio.com</a>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <a href="#" class="callbacks_nav callbacks2_nav prev">Previous</a><a href="#"
                                                                                       class="callbacks_nav callbacks2_nav next">Next</a>
                  <ul class="callbacks_tabs callbacks2_tabs">
                    <li class="callbacks2_s1"><a href="#" class="callbacks2_s1">1</a></li>
                    <li class="callbacks2_s2"><a href="#" class="callbacks2_s2">2</a></li>
                    <li class="callbacks2_s3 callbacks_here"><a href="#" class="callbacks2_s3">3</a></li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
          </div>
        </div>

      </div>
    </div>
    <div class="footer">
      <div class="container">
        <div class="footer-main" style="display: flex;justify-content: center;">
          <div class="col-md-6 footer-left">
                        <p style="text-align: center">© 浙ICP备2021005785号-1
                          <a target="_blank" href="#" title="网页模板">台州开眼互动信息技术有限公司</a></p>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  data() {
    return {
      currentIndex: 0,
      elementIds: [
        {name:'callbacks1_s0',Yes:true,},
        {name:'callbacks1_s1',Yes:false,},
        {name:'callbacks1_s2',Yes:false,},

      ],
      isVisible: true, // 控制显示或隐藏的标志
      num:1,
    }
  },
  mounted() {
    // this.showMessage();
    // setInterval(() => {
    //   this.showMessage();
    // }, 3000);
    // this.showMessage();
  },
  methods: {
    showMessage() {
      // this.currentIndex++
      console.log(this.currentIndex)
      // const element = document.getElementById(this.elementIds[this.currentIndex].name);
      // console.log(element)

      this.elementIds.forEach((item,index)=>{
       let  element = document.getElementById(this.elementIds[this.currentIndex].name);
        if(this.currentIndex === index){
          item.Yes = true
        }else{
          item.Yes = false
        }
        item.Yes === true? element.classList.add('callbacks1_on'): element.classList.remove('callbacks1_on');
      })


    }
  }
}

</script>
<style scoped lang="scss">
@import './img/promotion/bootstrap.css';
@import './img/promotion/promotion.css';
@import './img/promotion/famil.css';


.callbacks_nav {
  position: absolute;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  top: 50%;
  left: 0;
  opacity: 0.7;
  z-index: 3;
  text-indent: -9999px;
  overflow: hidden;
  text-decoration: none;
  height: 61px;
  width: 38px;
  background: transparent no-repeat left top;
  margin-top: -45px;
}

.callbacks_nav.next {
  left: auto;
  background-position: right top;
  right: 0;
}

//
//#flexiselDemo3 {
//  display: flex;
//  list-style: none;
//  padding: 0;
//  margin: 0;
//  animation: moveLeft 10s linear infinite; /* 应用动画 */
//}
//@keyframes moveLeft {
//  0% {
//    transform: translateX(0);
//  }
//  20%{
//    transform: translateX(-113.333px);
//  }
//  40% {
//    transform: translateX(-113.333px); /* 向左平移 100px */
//  }
//  60% {
//    transform: translateX(-226.666px); /* 向左平移 100px */
//  }
//  80% {
//    transform: translateX(-226.666px); /* 向左平移 100px */
//  }
//  100% {
//    transform: translateX(0); /* 向左平移 100px */
//  }
//}
</style>